<div class="m-333">
  <div *ngFor="let example of examples" class="mb-24">
    <echo-example-viewer [exampleId]="example" [path]="componentDirPath" [data]="exampleComponents[example]"></echo-example-viewer>
  </div>
</div>